import { keyframes } from "@mui/material/styles";

/**
 * The rooms' two colours (root ADR-036, the "Exhibitor Rooms" canvas): the
 * exhibitor is always indigo, the visitor always teal, on every screen and
 * in every mode, so a glance says whose half, whose line, whose button.
 * The start screen sits on its own dark ground.
 */
export const EXHIBITOR = {
	main: "#4f46e5",
	held: "#4338ca",
	tint: "#f4f4fd",
	chip: "#e2e4fb",
	ink: "#2b2a7a",
} as const;

export const VISITOR = {
	main: "#0f7c8c",
	held: "#0b5f6b",
	tint: "#ecf6f7",
	chip: "#d3ecee",
	ink: "#10384a",
	muted: "#4a6b70",
} as const;

export const DARK = {
	ground: "#0f1020",
	surface: "#171933",
	line: "#2a2e55",
	text: "#eef0ff",
	muted: "#9aa0c7",
	accent: "#6e67f0",
	accentSoft: "#a5a1ff",
	swap: "#2a2670",
	visitorSurface: "#12222b",
	visitorLine: "#1f3b47",
	visitorText: "#8ee3ee",
	visitorMuted: "#7fb9c2",
	live: "#3ddc97",
} as const;

export const FONT_DISPLAY = "'Inter Tight', Inter, system-ui, sans-serif";
export const FONT_MONO = "'JetBrains Mono', ui-monospace, monospace";

/** Every animation below is switched off for people who asked for less motion. */
export const REDUCED_MOTION = "@media (prefers-reduced-motion: reduce)";

export const ring = keyframes`0%{transform:scale(1);opacity:.6}100%{transform:scale(1.35,1.9);opacity:0}`;
export const roundRing = keyframes`0%{transform:scale(1);opacity:.55}100%{transform:scale(1.7);opacity:0}`;
export const wave = keyframes`0%{transform:scale(1);opacity:.5}100%{transform:scale(1.55);opacity:0}`;
export const bar = keyframes`0%,100%{transform:scaleY(.25)}50%{transform:scaleY(1)}`;
export const rise = keyframes`from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:none}`;
export const blink = keyframes`50%{opacity:0}`;
export const breathe = keyframes`0%,100%{opacity:.55}50%{opacity:1}`;
/** The status line's three dots, one after another. */
export const pulse = keyframes`0%,100%{opacity:.25;transform:translateY(0)}50%{opacity:1;transform:translateY(-2px)}`;
export const pop = keyframes`0%{transform:scale(.6);opacity:0}60%{transform:scale(1.06);opacity:1}100%{transform:scale(1)}`;
export const scan = keyframes`0%{top:6%}50%{top:90%}100%{top:6%}`;
export const float = keyframes`0%,100%{transform:translateY(0)}50%{transform:translateY(-6px)}`;
export const draw = keyframes`from{stroke-dashoffset:40}to{stroke-dashoffset:0}`;
export const toast = keyframes`0%{opacity:0;transform:translate(-50%,8px)}12%,80%{opacity:1;transform:translate(-50%,0)}100%{opacity:0;transform:translate(-50%,-6px)}`;

/** `animation` for an element, and none under reduced motion. */
export const animate = (value: string) => ({
	animation: value,
	[REDUCED_MOTION]: { animation: "none" },
});
